// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3_Qtj","ranges":"BmiRanges_ranges__2p1SG"};